import i18n from '@/i18n';
import store from '@/store';
import H_file from '@/helpers/file';
import H_time from '@/helpers/time';
import H_common from '@/helpers/common';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';
import H_systemClassMenu from '@/helpers/systemClassMenu';

export default {
  setIndex(list, riskStandard, factorySystemClassRows = []) {
    const _list = list.map((item) => {
      let _riskScore = {};
      riskStandard.forEach((standard) => {
        if (!item.audit_record_answers || !item.audit_record_answers.length) {
          _riskScore[standard.value] = 0;
        } else {
          _riskScore[standard.value] = item.audit_record_answers.filter(
            (answer) => answer.score === standard.score,
          ).length;
        }
      });
      let allScore = item.audit_record_answers.map((answer) => answer.score);
      const result = {
        icon: allScore.every((score) => score === 25 || score === 20)
          ? ' icon-check-circle-filled'
          : 'icon-risk-high-filled',
        color: allScore.some((score) => score === 23)
          ? 'red'
          : allScore.some((score) => score === 22)
          ? 'yellow'
          : allScore.some((score) => score === 21)
          ? 'blue'
          : 'green',
      }
      return {
        id: item.id,
        title: item.name,
        systemSubclasses: H_systemClassMenu.formatMultiSystemClassContentChips(
          {
            system_classes: item.system_classes,
            system_subclasses: item.system_subclasses,
            factory_system_classes: item.factory_system_classes,
            factory_system_subclasses: item.factory_system_subclasses,
          },
          { factorySystemClassRows },
        ),
        result,
        date: H_time.getDateDashFormat(item.record_at),
        auditees: item.auditees
          ? item.auditees.map(auditee => auditee.name).toString()
          : `${i18n.t('尚未回覆')}`,
        auditors: item.auditors
          ? item.auditors.map(auditor => auditor.name).toString()
          : `${i18n.t('尚未回覆')}`,
        download: [
          {
            text: `${i18n.t('匯出')} xlsx`,
            value: 'xlsx',
            id: 2,
          },
          {
            text: `${i18n.t('匯出')} csv`,
            value: 'csv',
            id: 3,
          },
          {
            text: `${i18n.t('匯出與列印')}`,
            value: 'print',
            id: 4,
          },
        ],
        riskScore: _riskScore,
      };
    });
    return _list;
  },
  getRecordData(record, factorySystemClassRows = []) {
    const {
      name,
      auditee,
      auditees,
      auditor,
      auditors,
      record_remark: recordRemark,
      record_at,
      review_at,
      file_images,
      review_remark: reviewRemark,
      review_draft: reviewDraft,
      chapters,
      risk_level: riskLevel,
      system_classes: systemClasses,
      system_subclasses: systemSubclasses,
      factory_system_classes: factorySystemClasses,
      factory_system_subclasses: factorySystemSubclasses,
      audit,
      alert,
      tasks,
      file_review_attaches,
      file_review_images,
    } = record;
    return {
      name,
      auditee,
      auditees,
      auditor,
      auditors,
      recordRemark,
      recordAt: H_time.getDateDashFormat(record_at, 'YYYY-MM-DD HH:mm:ss'),
      reviewAt: H_time.getDateDashFormat(review_at, 'YYYY-MM-DD HH:mm:ss'),
      images: H_file.setShowInModule(file_images),
      reviewRemark,
      reviewDraft,
      chapters,
      riskLevel,
      systemClasses,
      systemSubclasses,
      multiSystemSubclasses: H_systemClassMenu.formatMultiSystemClassContentChips(
        {
          system_classes: systemClasses,
          system_subclasses: systemSubclasses,
          factory_system_classes: factorySystemClasses,
          factory_system_subclasses: factorySystemSubclasses,
        },
        { factorySystemClassRows },
      ),
      auditId: audit ? audit.id : '',
      replyAttaches: H_file.setShowInModule(file_review_attaches),
      replyImages: H_file.setShowInModule(file_review_images),
      alert,
      tasks,
    };
  },
  getRecordAnswers(answers) {
    if (!answers || answers.length == 0) return [];
    const _answers = answers.map((answer) => {
      const lawList = H_common.setLawList(answer);
      return {
        questionId: answer.audit_question.id,
        questionVersionId: answer.audit_question_version
          ? answer.audit_question_version.id
          : '',
        templateId: answer.audit_question_template
          ? answer.audit_question_template.id
          : null,
        templateVersionId: answer.audit_question_template_version
          ? answer.audit_question_template_version.id
          : null,
        type: answer.audit_question_template ? 'template' : 'custom',
        articles: answer.article_versions,
        acts: answer.act_version_alls,
        riskSignal: [[...answer.effects], [...answer.factory_effects]],
        title: answer.title,
        payload: answer.payload,
        id: answer.id,
        images: H_file.setShowInModule(answer.file_images),
        remark: answer.remark,
        score: answer.score,
        riskLevel: answer.risk_level,
        lawList,
        focus: answer.keypoint,
        guidelineList: H_guidelineVersionAdmin.setShowRelatedGuideline(answer.related_guidelines),
      };
    });
    return _answers;
  },
  setRecordAnswersData(questions) {
    const currentFactory = store.state.app.factory;
    const data = questions.map((question) => {
      return {
        factory: currentFactory.id,
        score: question.score,
        remark: question.remark,
        images: H_file.setSubmitInModule(question.images),
        audit_question: question.id,
        audit_question_template: question.templateId,
        audit_question_version: question.versionId,
        audit_question_template_version: question.templateVersionId,
        risk_level: question.score,
        title: question.title,
        question_remark: question.questionRemark,
        keypoint: question.focus,
        payload: [question.payload],
        question_images: H_file.setSubmitInModule(question.questionImages),
        question_attaches: H_file.setSubmitInModule(question.questionAttaches),
        question_template_images: question.questionTempImages && question.questionTempImages.length
          ? question.questionTempImages.map(ques => ques.url)
          : [],
        question_template_attaches: question.questionTempAttaches && question.questionTempAttaches.length
          ? question.questionTempAttaches.map(ques => ques.url)
          : [],
        act_version_alls: question.actVersionAlls,
        article_versions: question.articleVersions,
        effects: question.effects.map(effect => effect.id),
        factory_effects: question.factoryEffects.map(effect => effect.id),
        related_guidelines: H_guidelineVersionAdmin.setShowToSubmitRelatedGuideline(question.guidelineList),
      };
    });
    return data;
  },
  getResultList(effects, questions, scoreStandard) {
    const _effects = JSON.parse(JSON.stringify(effects));
    _effects.push({
      id: 'keypoint',
      name: i18n.t('重點關注'),
    });
    const resultList = _effects.map((effect) => {
      const _effect = {
        leadingImage: effect.icon,
        text: effect.name,
      };
      scoreStandard.forEach((standard) => {
        _effect[`${standard.value}Num`] = this.getEffectNum(
          effect.id,
          questions,
          standard.score,
        );
      });
      return _effect;
    });
    return resultList;
  },
  getEffectNum(effectId, questions, score) {
    const _questions = questions.filter(ques => {
      if (effectId === 'keypoint' && ques.focus === 1) {
        return ques.score === score;
      } else {
        let quesEffectIdList = [];
        if (ques.riskSignal) {
          if (ques.riskSignal[0] && ques.riskSignal[0].length) {
            quesEffectIdList = [...quesEffectIdList, ...ques.riskSignal[0].map(r => r.id)];
          }
          if (ques.riskSignal[1] && ques.riskSignal[1].length) {
            quesEffectIdList = [...quesEffectIdList, ...ques.riskSignal[1].map(r => r.id)];
          }
        }
        return quesEffectIdList.includes(effectId) && ques.score === score;
      }
    });
    return _questions.length;
  },
}